import { useEffect } from 'react';

/*
 * useScrollToTopOnMount — reset scroll position when a screen is entered.
 * ---------------------------------------------------------------------------
 * The window reset is load-bearing: on these two-pane screens the document can
 * be scrolled such that the site picker is pushed out of view on re-entry.
 * The optional innerRef resets a screen's own scroll container (e.g. the right
 * pane) when the ref is readily attachable in the same component.
 */
export function useScrollToTopOnMount(innerRef) {
  useEffect(() => {
    window.scrollTo(0, 0);                 // load-bearing: fixes the hidden site picker
    if (innerRef && innerRef.current) innerRef.current.scrollTop = 0;  // optional
    // eslint-disable-next-line react-hooks/exhaustive-deps -- innerRef is omitted deliberately: every caller passes a useRef object (or nothing), whose identity is stable for the component's lifetime, so listing it could never re-fire the effect and mount-only is the intended cadence.
  }, []);                                  // mount = each entry to the route
}
